//
//
//
//
//
//
//
//

export default {
  name: 'app',
  watch: {  
    $route(to, from) {  
      if(window.$action){
          window.$action._init();
      }else{
        if(process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'test') {
          //test环境
          window.$action = new postdata({
              debug:true,
              appkey:'hunbasha_wap' 
          })   
        }else{
          //ga环境
          window.$action = new postdata({
            appkey:'hunbasha_wap' 
          })
        }
      }
    }  
  }
}



// WEBPACK FOOTER //
// ./src/App.vue